import { Link, useSearchParams } from "react-router-dom";
import { calculateLeftTime } from "../../../../../utils/time";

const MessagesListItem = ({ message }) => {
  const [searchParams] = useSearchParams();
  const chatSession = searchParams.get("session_id");

  const putTime = () => {
    if (message.last_message) {
      return calculateLeftTime(message.last_message_at);
    }
  };

  return (
    <li>
      <Link
        to={`/messages/2/09900000000?session_id=${message.id}`}
        state={{ image: message.image, name: message.name }}
        className={`flex w-full hover:shadow duration-500 bg-white p-3 shadow-custom-sm rounded-xl gap-3 border ${chatSession == message.id ? "border-primary" : "border-gray-100"} `}
      >
        <div className="flex w-full flex-col gap-2">
          <div className="flex items-center justify-between w-full">
            <span> {message.title} </span>
          </div>

          <div className="flex items-center justify-between w-full">
            <p className="text-sm text-gray-500 2xm:whitespace-nowrap 2xm:max-h-max max-h-5 xl:max-w-2xl md:max-w-xl sm:max-w-md max-w-xs overflow-hidden overflow-ellipsis ml-1.5 break-words">
              {putTime()}
            </p>
            {/* {message.message_count > 0 && (
              <span className="bg-primary flex-shrink-0 rounded-lg py-1 text-sm text-white flex items-center justify-center w-6 h-6">
                {message.message_count}
              </span>
            )} */}
          </div>
        </div>
      </Link>
    </li>
  );
};

export default MessagesListItem;
